import styled from 'styled-components';

const StyledGpPayScheduleDetailsCards = styled.div`
  color: pink;
`;
export function GpPayScheduleDetailsCards() {
  return (
    <StyledGpPayScheduleDetailsCards>
      <h1>Welcome to GpPayScheduleDetailsCards!</h1>
    </StyledGpPayScheduleDetailsCards>
  );
}

export default GpPayScheduleDetailsCards;
